import { Pipe, PipeTransform } from '@angular/core';

import type { Translation } from '@cds/betting-offer';

@Pipe({
    name: 'msTranslate',
    standalone: true,
})
export class TranslationToStringPipe implements PipeTransform {
    transform(value: Translation): string {
        return (value && (value.short || value.value)) || '';
    }
}
